<div class="modal-container">
  <div class="modal-header">
    <h3 class="modal-title-text"><i class="fa fa-file-invoice"></i> Datos para Factura AFIP</h3>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="razonSocial" class="form-label">Razón Social</label>
        <input
          #razonSocial="ngModel"
          [(ngModel)]="datos.razonSocial"
          name="razonSocial"
          type="text"
          class="form-control custom-input"
          id="razonSocial"
          required
          placeholder="Razón Social"
        />
        <small
          class="text-danger font-14"
          *ngIf="razonSocial.touched && razonSocial.invalid"
        >
          Razón Social es requerido
        </small>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <label for="documentoAfip" class="form-label">Tipo de Documento</label>
        <select
          #documentoAfip="ngModel"
          [(ngModel)]="datos.tipodocumento"
          name="documentoAfip"
          id="documentoAfip"
          class="form-control custom-select"
          required
        >
          <option *ngFor="let c of documentosAfip.list" [value]="c.id">
            {{ c.descripcion }}
          </option>
        </select>
        <small
          class="text-danger font-14"
          *ngIf="documentoAfip.touched && documentoAfip.invalid"
        >
          Tipo de Documento es requerido
        </small>
      </div>
      <div class="form-group col-md-6">
        <label for="nroDocumento" class="form-label">Nro Documento</label>
        <input
          #nroDocumento="ngModel"
          [(ngModel)]="datos.nroDocumento"
          name="nroDocumento"
          type="text"
          class="form-control custom-input"
          id="nroDocumento"
          required
          placeholder="Nro Documento"
        />
        <small
          class="text-danger font-14"
          *ngIf="nroDocumento.touched && nroDocumento.invalid"
        >
          Nro Documento es requerido
        </small>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <label for="formaPago" class="form-label">Forma de Pago</label>
        <select
          #formaPago="ngModel"
          [(ngModel)]="datos.formaPago"
          name="formaPago"
          id="formaPago"
          class="form-control custom-select"
          required
        >
          <option *ngFor="let c of formaDePago.list" [value]="c.id">
            {{ c.descripcion }}
          </option>
        </select>
        <div
          class="alert alert-danger custom-alert"
          *ngIf="formaPago.touched && formaPago.invalid"
        >
          Forma de Pago es requerido
        </div>
      </div>
      <div class="form-group col-md-6">
        <label for="total" class="form-label">Total</label>
        <input
          #totalInput="ngModel"
          [(ngModel)]="datos.total"
          name="total"
          type="number" 
          class="form-control custom-input"
          id="total"
          required
          placeholder="Total"
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <label for="description" class="form-label">Comentario</label>
        <textarea 
          id="description" 
          class="form-control custom-textarea" 
          [(ngModel)]="datos.description" 
          name="description" 
          rows="3" 
          placeholder="Comentario o descripción adicional..."
        ></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="cancelar()">
      No Enviar
    </button>
    <button type="button" class="btn btn-primary" (click)="aceptar()">
      <i class="fa fa-paper-plane"></i> Enviar a Afip
    </button>
  </div>
</div>